<template>
    <div class="apprentice-simple-card">
        <div class="add-school-users">
            <b-button
                class="btn-upload btn-assignment-import-list"
                v-if="$authUser.isAdmin"
                variant="primary"
                @click="importList">
                {{ $t('school.import_list') }}
            </b-button>
            <b-button
                class="btn-add btn-add-school-users"
                v-b-modal="'school-add-user-modal'"
                variant="primary">
                {{ $t('school.new_user') }}
            </b-button>
        </div>

        <design-2021-school-accounts-index-add-user-modal-component
            @update-table="updateTable"></design-2021-school-accounts-index-add-user-modal-component>

        <v-server-table
            class="school-users-server-table"
            ref="table"
            :url="url"
            :columns="columns"
            :options="options"
            name="schools-accounts-table">
            <div
                slot="actions"
                slot-scope="{ row }">
                <div class="actions">
                    <b-button
                        class="btn-show btn-show-accounts"
                        variant="primary-icon-only"
                        @click="onSelect(row.id)"
                        :v-b-tooltip="$t('school.take_over_account')"></b-button>

                    <b-button
                        class="btn-settings btn-settings-accounts"
                        v-b-modal="'school-update-user-modal' + row.id"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('common.edit')"></b-button>

                    <design-2021-school-accounts-index-update-user-modal-component
                        :user="row"
                        @update-table="updateTable"></design-2021-school-accounts-index-update-user-modal-component>

                    <b-button
                        class="btn-remove btn-remove-accounts"
                        variant="danger-icon-only"
                        @click="onRemove(row.id)"
                        :v-b-tooltip="$t('common.delete')"></b-button>
                </div>
            </div>
        </v-server-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-accounts-index-component',
    data() {
        return {
            columns: ['full_name', 'email', 'type_name', 'actions'],
            options: {
                texts: { filterPlaceholder: this.$t('common.search') },
                sortIcon: {
                    base: 'fad',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down',
                },
                headings: {
                    full_name: this.$t('common.name'),
                    email: this.$t('common.email'),
                    type_name: this.$t('common.type'),
                    actions: this.$t('common.actions'),
                },
                sortable: ['full_name', 'email', 'type_name'],
                saveState: true,
                requestFunction(data) {
                    if (data.orderBy) {
                        switch (data.orderBy) {
                            case 'type_name':
                                data.orderBy = 'type';
                                break;
                            case 'full_name':
                                data.orderBy = 'surname';
                                break;
                        }
                    }

                    data.byColumn = 'name';
                    return this.axios.get(this.url, { params: data });
                },
                filterable: ['full_name'],
                filterAlgorithm: {
                    full_name(row, query) {
                        return row.preposition.length
                            ? (row.name + ' ' + row.preposition + ' ' + row.surname).includes(query)
                            : (row.first_name + ' ' + row.surname).includes(query);
                    },
                },
            },

            url: this.routes.schoolGetAccounts(),
        };
    },
    methods: {
        updateTable() {
            this.$refs.table.refresh();
        },
        onSelect(user_id) {
            window.location.href = baseUrl + '/school/select/user/' + user_id;
        },
        onRemove(user_id) {
            this.alert
                .confirm(
                    this.$t('school.delete_account'),
                    this.$t('school.are_you_sure_you_want_to_delete_this_account'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete(this.routes.schoolAccountUserDelete(user_id)).then(
                            (response) => {
                                this.updateTable();

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        importList() {
            window.location.href = this.routes.schoolAccountImport();
        },
    },
};
</script>

<style scoped lang="scss">
.add-school-users {
    display: flex;
    flex-wrap: wrap;
    flex: 1 0 100%;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .btn {
        flex: 1 0 100%;
        width: 100%;

        &:not(:last-of-type) {
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
        }
    }
}

.actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .btn {
        font-size: 1.125rem;
    }

    .btn-edit-roadmap:before {
        margin-right: 0;
    }
}

.school-users-server-table ::v-deep {
    .VueTables__search-field {
        label {
            display: none;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .add-school-users {
        .btn {
            flex: 0 1 auto;
            width: auto;

            &:not(:last-of-type) {
                margin-bottom: 0;
            }
        }

        .btn-assignment-import-list {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
